import { render } from "./ManageHighlights.vue?vue&type=template&id=2d55ed2a"
import script from "./ManageHighlights.vue?vue&type=script&lang=js"
export * from "./ManageHighlights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Highlights/ManageHighlights.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d55ed2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d55ed2a', __exports__)) {
    api.reload('2d55ed2a', __exports__)
  }
  
  module.hot.accept("./ManageHighlights.vue?vue&type=template&id=2d55ed2a", () => {
    api.rerender('2d55ed2a', render)
  })

}


export default __exports__